import OrgPayment from "@/atomic/organisms/orgPayment";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";

export default function HomeView({
  goToVehicles,
  items,
  plate,
  isLoading,
  onChange,
  selectables,
  goBack,
  goToProfile,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header title="Débitos" hasLeftButton goBack={goBack} />
      <div className="absolute flex w-full justify-center h-[calc(280px)]">
        <img
          src={"/iStock.png"}
          width={1505}
          height={291}
          alt="iStock"
          className="absolute brightness-50 h-[calc(280px)] object-cover w-full max-w-[calc(900px)] object-top"
        />
      </div>
      <main className="z-10 mt-[calc(140px)] p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col w-[calc(480px)]">
          <div className={`w-full mb-[calc(120px)] pb-[calc(120px)]`}>
            <div className="flex items-center">
              <img
                src={"/icon-car.png"}
                width={24}
                height={24}
                alt="icon car"
              />
              <p className="ml-1 text-white">Seus veículos:</p>
            </div>
            <div className="p-3 mt-1 bg-white rounded-xl shadow-md flex w-full justify-between">
              <div>
                <p className="text-lg uppercase">{plate}</p>
              </div>
              <button type="button" onClick={goToVehicles}>
                <img
                  src={"/icon-search.png"}
                  width={24}
                  height={24}
                  alt="Trocar de veículo"
                />
              </button>
            </div>

            <>
              <h2 className="text-base text-black mt-4">Débitos</h2>
              <div className="w-full h-px bg-slate-300 mt-4 mb-3" />
              {items?.length > 0 && (
                <div className="mb-4 mt-7">
                  <div className="flex items-center w-full">
                    <input
                      type="checkbox"
                      name="all"
                      className="w-6 h-6 accent-black"
                      onChange={onChange}
                      checked={items?.length === selectables?.length}
                    />
                    <p className="text-sm ml-6">
                      {"Selecionar "}
                      {items?.length} passage
                      {items?.length !== 1 ? "ns" : "m"} em aberto
                    </p>
                  </div>
                  <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                </div>
              )}
              {items?.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center w-full">
                    <input
                      type="checkbox"
                      name={item.id}
                      className="w-6 h-6 accent-black"
                      onChange={onChange}
                      checked={
                        selectables?.some(
                          (selectable) => selectable.name === item.id,
                        ) ?? false
                      }
                    />
                    <div className="ml-6 w-full">
                      <div className="flex w-full justify-between">
                        <p className="text-base uppercase">{plate}</p>
                        {item?.daysLeft > 0 && item.hasDate && (
                          <p className="bg-black text-white text-sm p-1 rounded-lg">
                            Vencido há {item?.daysLeft} dia(s)
                          </p>
                        )}
                      </div>
                      <div className="flex w-full justify-between">
                        <p className="text-sm blur-sm">{item.dueDate}</p>
                        {item?.originalPrice !== item?.price && (
                          <p className="text-sm line-through">
                            R$ {item?.originalPrice}
                          </p>
                        )}
                      </div>
                      <div className="flex w-full justify-between">
                        <p className="text-base">
                          {item?.original?.nmConcessionaria}
                        </p>
                      </div>
                      <div className="flex w-full justify-between">
                        <p className="font-bold text-base">
                          {item?.original?.nmPraca}
                        </p>
                        <p className="font-bold text-base">R$ {item?.price}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                </div>
              ))}
            </>
            {items?.length === 0 && (
              <div className="w-full flex justify-center items-center flex-col mt-10">
                <img
                  src={"/icon-car-front-close.png"}
                  width={48}
                  height={48}
                  alt="Ícone carro"
                  className="mt-6"
                />
                <h2 className="mt-1 text-sm text-center px-8">
                  Nenhuma passagem encontrada. <br/>
                  As passagens podem levar até 48 horas para ficarem disponíveis
                  no sistema para pagamento. 
                </h2>
              </div>
            )}
            {items?.length === 0 && (
              <div className="border-1 border border-gray-400 w-full p-4 rounded-lg flex items-center mb-5 mt-20">
                <img
                  src={"/icon-square.png"}
                  width={40}
                  height={40}
                  alt="Informação"
                  className="h-[calc(40px)] w-[calc(40px)]"
                />
                <p className="ml-2 text-gray-600 text-sm">
                Se o veículo possui TAG a cobrança é automática. Verifique se a TAG está ativa e se os débitos aparecem na fatura de sua operadora. Caso contrário, consulte possíveis pendências aqui.
                </p>
              </div>
            )}
          </div>
          {items?.length > 0 && <OrgPayment />}
        </article>
      </main>
      {isLoading && <Loading />}
    </div>
  );
}
